import { FunctionComponent } from "react";

import {
  AffiliateLinkProps,
  useAffiliateContext,
} from "@ui/context/affilliate-context";

/**
 * AffiliateLink is used by `duet-ui` for any potential affiliate links.
 * For example this is used in `DangerouslySetCMSMarkup` for potential affiliate
 * links as well as in product related components.
 *
 * AffiliateLink uses the affiliate context to render the actual component that
 * handles the affiliate functionality.
 *
 * `duet-framework` injects the `AgoraLink` here via the affiliate context.
 */
const AffiliateLink: FunctionComponent<AffiliateLinkProps> = ({
  analyticsPayload,
  includeClickAnalytics,
  includeViewAnalytics,
  children,
  ...props
}) => {
  const context = useAffiliateContext();
  if (!context || !context.linkComponent) {
    return <a {...props}>{children}</a>;
  }
  const extraProps = {
    analyticsPayload,
    includeClickAnalytics,
    includeViewAnalytics,
  };
  const Component = context.linkComponent;
  return (
    <Component {...extraProps} {...props}>
      {children}
    </Component>
  );
};

export default AffiliateLink;
